import { useGetChatBotJWTQuery, zendeskchatScript } from "@amzn/rangoli-seller-desktop-api-utils/src/index";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";

const ChatBot = (): React.JSX.Element => {
    const { data: jwtToken } = useGetChatBotJWTQuery();

    useEffect(() => {
        if (jwtToken?.authToken) {
            handleChatScript();
        }
    }, [jwtToken?.authToken]);

    const handleChatScript = async () => {
        const script = document.createElement("script");
        script.id = "ze-snippet";
        script.src = `${zendeskchatScript}`;
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => {
            window.zE("messenger", "loginUser", function (callback) {
                callback(jwtToken?.authToken);
            });
        };
    };

    return <></>;
};

export default observer(ChatBot);